import {isActive} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {getEvent} from './event'

export const isLastAvailableOccurrence = (state: State) =>
  isActive(getEvent(state)) && state.upcomingOccurrencesCount === 1

export const getAllOccurrencesCount = (state: State) => state.upcomingOccurrencesCount

export const getMoreOccurrencesCount = (state: State) =>
  isActive(getEvent(state)) ? state.upcomingOccurrencesCount - 1 : state.upcomingOccurrencesCount

export const isLoadingOccurrences = (state: State) => state.occurrences.loading

export const getEventOccurrences = (state: State) => state.occurrences.events

export const getOccurrencesDates = (state: State) => state.occurrences.dates

export const getOccurrencesTotal = (state: State) => state.occurrences.total

export const getUpcomingOccurrencesSuggestions = (state: State) => state.upcomingOccurrencesSuggestions
